import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

/** Mark a single notification as read. */
export const markNotificationRead = createAsyncThunk(
  'reports/markNotificationRead',
  async (notificationId: string, { rejectWithValue }) => {
    try {
      const res = await fetch(REPORTS.MARK_NOTIFICATION_READ, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify({ notificationId }),
      });
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to mark notification as read');
      }
      return { notificationId };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
